import urls from "global/constants/UrlConstants";
import { WorkspaceBranding } from "types/workspace";
import { getCallParams, getFileCallParams, makeCall } from "utils/service";

export const fetchWorkspaceBranding = async (
  workspaceId: string,
): Promise<WorkspaceBranding> => {
  try {
    const callParams = await getCallParams("GET");
    const response: WorkspaceBranding = await makeCall(
      `${urls.WORKSPACE_BASE}/${workspaceId}/branding`,
      callParams,
    );
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const updateWorkspaceBranding = async (
  workspaceId: string,
  branding: WorkspaceBranding,
) => {
  try {
    const callParams = await getCallParams("PUT", branding);
    return await makeCall(
      `${urls.WORKSPACE_BASE}/${workspaceId}/branding`,
      callParams,
    );
  } catch (error: any) {
    throw error;
  }
};

/** Reuses the shared CDN logo upload; returns the uploaded URL (ApiResponse.message). */
export const uploadWorkspaceLogo = async (file: FormData): Promise<string> => {
  const callParams = await getFileCallParams("POST", file);
  const response: any = await makeCall(urls.UPLOAD_BRANDING_LOGO, callParams);
  return response?.message || response?.logoUrl || response?.url || "";
};
